import { baseFetch, getUrlWithSearchParams } from "@helium10/re-core";
import { apiUpgrade } from "../consts/links";
export const upgradeProcess = async (params, signal) => {
    return await baseFetch({
        url: getUrlWithSearchParams(apiUpgrade, {}),
        method: "POST",
        params: {
            ...(params?.downgrade && { downgrade: params?.downgrade }),
            ...(params?.upgrade && { upgrade: params?.upgrade }),
            ...(params?.period && { period: params?.period }),
            captchaTokenV3: params?.captchaTokenV3 ?? "",
            coupon: params?.coupon ?? "",
            plan: params?.plan ?? "",
            items: JSON.stringify(params?.items),
            utm_campaign: params?.utm_campaign ?? "",
            eventSource: params?.eventSource ?? "",
            module: params?.module ?? "",
        },
        signal,
    });
};
